import { ActionType, Integration, IntegrationStatus } from '../services/api/types';
import { NotificationModel } from './AccountNotifications';
import { HasRoyalMailOba } from './IsRoyalMailOba';

export function AccountLinkingStatusHelper(status: IntegrationStatus, integrationName: string, accountName: string) {
  switch (status) {
    case 'Submitted':
      return `We have received your request to link your ${integrationName}. To monitor its progress click`;

    case 'Rejected':
      return `Your request to link your ${integrationName} has been rejected.`;

    case 'Active':
      return `Your request to link your ${integrationName} has been successful.`;

    case 'ConfigurationRequired':
      return `Your ${integrationName} account (${accountName}) needs setting up. Click to configure`;

    default:
      return status;
  }
}

function GetNotificationColour(s: IntegrationStatus): 'info' | 'warning' | 'error' | 'success' {
  switch (s) {
    case 'Rejected':
      return 'error';
    case 'ConfigurationRequired':
      return 'warning';
    case 'Active':
      return 'success';
    default:
      return 'info';
  }
}

function ShouldShowCloseButton(s: IntegrationStatus): boolean {
  switch (s) {
    case 'ConfigurationRequired':
    case 'Rejected':
    case 'Active':
      return true;
    default:
      return false;
  }
}

function GetNotificationActions(s: IntegrationStatus): ActionType[] {
  switch (s) {
    case 'Rejected':
      return [];
    default:
      return ['Configure'];
  }
}

export function GetAccountNotifications(integrations: Integration[]): NotificationModel[] {
  var notifications: NotificationModel[] = [];

  // Just for RM OBA
  var statuses: IntegrationStatus[] = ['Submitted', 'Rejected', 'Active'];
  statuses.forEach((s) => {
    var rmObaIntegration = integrations.find((i) => HasRoyalMailOba(i, s));
    rmObaIntegration?.accounts.forEach((a) => {
      var uid = `${a.id}:${s}`;
      notifications.push({
        id: uid,
        integrationSlug: rmObaIntegration.slug,
        integrationType: rmObaIntegration.type,
        accountId: a.id,
        actions: GetNotificationActions(s),
        showClose: ShouldShowCloseButton(s),
        color: GetNotificationColour(s),
        note: AccountLinkingStatusHelper(s, rmObaIntegration.name, a.name),
        configRequired: false,
      });
    });
  });

  // Prestashop and other integrations which require setup, post create.
  var statusesForConfig: IntegrationStatus[] = ['ConfigurationRequired'];
  statusesForConfig.forEach((s) => {
    var mainIntegration = integrations.find((i) => i.accounts.find((a) => a.status === s));
    mainIntegration?.accounts
      .filter((a) => a.status === s)
      .forEach((a) => {
        var uid = `${a.id}:${s}`;
        notifications.push({
          id: uid,
          integrationSlug: mainIntegration.slug,
          integrationType: mainIntegration.type,
          accountId: a.id,
          actions: GetNotificationActions(s),
          showClose: ShouldShowCloseButton(s),
          color: GetNotificationColour(s),
          note: AccountLinkingStatusHelper(s, mainIntegration.name, a.name),
          configRequired: true,
        });
      });
  });

  return notifications;
}
